import React, { useEffect, useState } from "react";
import { Button, Col, Modal, Row } from 'react-materialize';
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import ButtonUI from '../../../../../../components/UI/ButtonUI';
import { BackButton, Input, ListPagination, Subtitle, Title } from "../../../../../../components/UI/ComponentsUI";
import LinePickingService from "../../../../../../services/LinePickingService";
import { onValueChange } from "../../../../../../utils/handleChangeHooks";
import { showMessageToastCustom, translate } from "../../../../../../utils/util";

const QrCodeList = (props) => {
  const [qrCodeCalls, setqrCodeCalls] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [filter, setFilter] = useState({ partNumber: "", pdu: "" });
  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    onSearch();
    // eslint-disable-next-line
  }, [currentPage]);

  const onSearch = () => {
    filter.pageIndex = currentPage;
    props.searchQRCodeCalls(
      filter,
      { PageSize: 25, PageIndex: currentPage },
      (response) => {
        if (response.items) {
          setqrCodeCalls(response.items);
        }
      }
    );
  };

  const onDelete = (id) => {
    props.deleteQrCodeCall(id,
      () => {
        setOpenModal(false);
        onSearch();
        showMessageToastCustom(translate('confirmed', 'general'), translate('sucess-to-delete', 'general'), 8000, 'mdi mdi-checkbox-marked-circle-outline green-text');
      });
  }

  const renderItem = (item) => {
    return (
      <>
        <span
          className="title sixth-text-color right"
          style={{ position: 'absolute', marginTop: '8px', right: '20px', zIndex: '999' }}
        >
          <Row>
            <Col className="col s12" style={{ padding: 0 }}>
              <Modal
                open={openModal}
                id={`modal-id-${item.id}`}
                fixedFooter
                style={{ marginTop: "15px", maxHeight: "60%" }}
                actions={
                  <Row className="center" style={{ height: "60%" }}>
                    <Button className="col s6 btn waves-effect waves-light btn-flat" modal="close" onClick={() => setOpenModal(false)}>
                      {translate('cancel', 'general')}
                    </Button>
                    <ButtonUI
                      onClick={() => onDelete(item.id)}
                      text={translate('confirm', 'general')}
                    />
                  </Row>
                }>
                <div>
                  <Row className="center">
                    <div className="sixth-text-color center">
                      <span className="col s12">
                        <i className="material-icons large">info_outline</i>
                      </span>
                      <span className="title col s12">{translate('messages.confirmation-delete', 'plant')}</span>
                    </div>
                  </Row>
                </div>
              </Modal>
              <i className="material-icons sixth-text-color" onClick={() => setOpenModal(true)} style={{ fontSize: '1.75rem', cursor: 'pointer' }}>delete</i>
            </Col>
          </Row>
        </span>
        <div>
          <span className="title sixth-text-color">
            <i className="mdi mdi-qrCode" /> {item.partNumber}
          </span>
          <span
            className="truncate second-text-color"
            style={{ marginLeft: "10px" }}
          >
            <i className="mdi mdi-garage" /> {item.pdu}
          </span>
        </div>
      </>
    );
  }

  const onChange = (event) => {
    onValueChange(event, filter, setFilter);
  };

  return (
    <div>
      <BackButton {...props} />
      <div className="container-fluid h-65">
        <div className="row">
          <Title
            icon="mdi mdi mdi-qrcode"
            label={translate("picking.qrCodeCall", "expedition")}
          />
          <Subtitle
            icon="mdi mdi-clipboard-list-outline"
            label={translate("list-qrCodeCall", "qrcode-picking")}
          />
        </div>
      </div>
      <div className="container" style={{ marginTop: "25px" }}>
        <div className="row">
          <div className="input-field padding col s5">
            <Input
              id="partNumber"
              name="partNumber"
              placeholder={translate("picking.partnumber", "expedition")}
              type="text"
              onChange={onChange}
            />
          </div>
          <div className="input-field padding col s5">
            <Input
              id="pdu"
              name="pdu"
              placeholder={translate("fields.pdu", "delivery")}
              type="text"
              onChange={onChange}
            />
          </div>
          <div className="col s1" style={{ paddingTop: "10px" }}>
            <button
              className="btn-floating btn-Small btn-principal waves-effect waves-light"
              type="button"
              onClick={onSearch}
            >
              <i className="Small material-icons">search</i>
            </button>
          </div>
        </div>
      </div>
      <div className="container-fluid" style={{ marginTop: "0px" }}>
        <div id="qrCodesList" className="container-fluid">
          <ListPagination
            page={props.qrCodes?.totalPages}
            current={{ currentPage, setCurrentPage }}
            data={qrCodeCalls.map((item, index) => {
              return renderItem(item);
            })}
          />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.userReducer.user,
    qrCodes: state.linePickingReducer.qrCodes,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    searchQRCodeCalls: (filter, pagination, callback) => {
      dispatch(LinePickingService.searchQRCodeCalls(filter, pagination, callback));
    },
    deleteQrCodeCall: (filter, callback) => {
      dispatch(LinePickingService.deleteQrCodeCall(filter, callback));
    },
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(QrCodeList));
